// extracted by mini-css-extract-plugin
export default {"LogoContainer":"Logo_LogoContainer__XMmyA","Logo":"Logo_Logo__NotdH"};